import api from '@/plugins/axios';
import { mountUrl } from './helper';

const BASE_PATH = 'budget_attachments';

export default {
  async create(budgetId, data) {
    const url = mountUrl(`/${BASE_PATH}/${budgetId}/attachment`);
    return api.post(url, data);
  },
  async search(queryParams) {
    const url = mountUrl(`/${BASE_PATH}`, queryParams);
    return api.get(url);
  },
  async getById(id) {
    const url = mountUrl(`/${BASE_PATH}/${id}`);
    return api.get(url);
  },
  async update(id, data) {
    const url = mountUrl(`/${BASE_PATH}/${id}`);
    return api.put(url, data);
  },
  async inactivate(budgetId, id) {
    const url = mountUrl(`/${BASE_PATH}/${budgetId}/${id}`);
    return api.delete(url);
  }
};
